/**
 * Created by Elia Rohana on 20/02/2018.
 */

export enum CurationStatusValue {
  Curated = 'Curated',
  PendingCuration = 'PendingCuration'
}

export interface CurationStatus {
  value: CurationStatusValue;
  partiallyCurated?: boolean;
  lastCurationDate?: Date;
  hasCurationInProgress?: boolean;
}

